export function getNameFromCode<T extends { code: string; name: string }>(
	options: T[],
	code: string,
): string | undefined {
	const found = options.find(option => option.code === code);
	return found?.name;
}
